export const StickySituation = {
    // Header
    title:"Sticky Situation",
    subtitle:"Godot | Solo Dev | 2D",
    genre:"Puzzle/Movement",

    //Hero
    poster:"/Thumbnails/Sticky-Thumbnail.png",
    releaseDate:"In Development",
    studioName:"",
    teamSize:"Solo Developed",
    platforms:"PC",
    responsiblities:[
        `Solo-developed a 2D movement game in Godot, adhering to the full lifecycle from concept to deployment.`,
    ],
    engine:"Godot",
    projectLength:"~5 months, Ongoing",


    //Description
    desc:[
        `A solo dev project to recreate and expand upon the gameplay mechanics of the Kuru Kuru Kuruin game series for the GBA and GameCube.\n\nThis is a puzzle/movement game (and potential rage game) that has the player control a constantly spinning stick in order to navigate a maze.`,
        
        `Hitting the stick against the wall causes it to crack, 3 hits and it breaks entirely!\n\nTry to get to the end of level with your Stick intact! Watch out for obstacles!`,
        ``
    ],
    img:["/Games/Sticky Situation/Sticky-GameDemo.png", "/Games/Sticky Situation/Sticky-StickCollage.png", "/Games/Sticky Situation/Sticky-WinScreen.png"

    ],

    contributions:[
        `Solo-developed a 2D movement game in Godot, adhering to the full lifecycle from concept to deployment.`,
        `Implemented a flexible JSON-based save system allowing for easy expansion of game states and player progress`,
        `Refined gameplay mechanics through iterative playtesting to balance difficulty and ensure engaging player experiences.`
    ],



    thumbnail:"/Thumbnails/Sticky-Thumbnail.png",
    type:"Solo Games",
    badge:"./Project Badges/godot-gdscript-solo.svg",
    shortDesc:`A solo dev project to recreate and expand upon the gameplay mechanics of the Kuru Kuru Kuruin game series for the GBA and GameCube.\n\nThis is a puzzle/movement game (and potential rage game) that has the player control a constantly spinning stick in order to navigate a maze.`,
    url:"/projects/Sticky Situation",




    //Special Sections
    downloadable:"yes",
    credits:"",
    awards:"",
    awardImg:[

    ],





    //Links
    githubURL:"https://github.com/DrakeMitchell/Sticky-Situation",
    itchioURL:"https://severedx.itch.io/sticky-situation",
    itchioEmbedURL:"https://itch.io/embed/3256309?linkback=true&amp;link_color=2b7ff4&amp;border_color=be4292",
    steamURL:"",


}